module.exports = __webpack_public_path__ + "img/Mage-bloodelf-m-70.973d272c.gif";